/* Das Coeur - Personally Yours race list personalizer (product page).
   Markup, colours and @font-face live in snippets/race-list-personalizer.liquid.

   NOTE 1: never read form.id on a Shopify product form. The form contains
   <input name="id"> for the variant, and HTMLFormElement exposes named controls
   as properties, so form.id returns that INPUT, not the id string. Use
   form.getAttribute('id').

   NOTE 2: do not use document.fonts.ready to trigger the re-fit. A font is only
   requested when first used, so fonts.ready can resolve BEFORE Graduate has
   loaded and the text then gets sized against the fallback and overflows.
   Use document.fonts.load('16px "Graduate"') instead - it forces the load and
   resolves once the face is actually available. */
(function(){
  var MAXFIT = 140;
  var PRINT_FONT = '16px "Graduate"';

  function formIdOf(f){ return f ? f.getAttribute('id') : null; }

  function titleCase(s){
    return s.toLowerCase().replace(/(^|[\s\-\/(])([a-z0-9])/g, function(m,p,c){ return p + c.toUpperCase(); });
  }

  function clean(raw, maxLines){
    var lines = String(raw || '').split(/\r?\n/).map(function(l){
      return l.replace(/\s+/g,' ').trim();
    }).filter(function(l){ return l.length > 0; });
    return { lines: lines.slice(0, maxLines), overflow: Math.max(0, lines.length - maxLines) };
  }

  function fit(box, text){
    var maxW = box.clientWidth, maxH = box.clientHeight;
    if (!maxW || !maxH) return;
    var lo = 4, hi = MAXFIT, best = 4;
    while (lo <= hi){
      var mid = Math.floor((lo + hi) / 2);
      text.style.fontSize = mid + 'px';
      if (text.offsetWidth <= maxW && text.offsetHeight <= maxH){ best = mid; lo = mid + 1; }
      else { hi = mid - 1; }
    }
    text.style.fontSize = best + 'px';
  }

  function realForm(root){
    var byId = document.getElementById(root.dataset.formId);
    if (byId && byId.tagName === 'FORM') return byId;
    var addBtn = document.querySelector('product-form [name="add"]') || document.querySelector('[name="add"]');
    if (addBtn && addBtn.form) return addBtn.form;
    return document.querySelector('product-form form[action*="/cart/add"]');
  }

  function init(root){
    if (root.dataset.dcReady === '1') return;
    root.dataset.dcReady = '1';

    var input = root.querySelector('[data-dc-input]');
    var box   = root.querySelector('[data-dc-print]');
    var text  = root.querySelector('[data-dc-text]');
    var empty = root.querySelector('[data-dc-empty]');
    var count = root.querySelector('[data-dc-count]');
    var msg   = root.querySelector('[data-dc-msg]');
    if (!input || !box || !text) return;

    var maxLines = parseInt(root.dataset.maxLines, 10) || 20;
    var maxChars = parseInt(root.dataset.maxChars, 10) || 26;
    var required = root.dataset.required === 'true';

    var form = realForm(root);
    var fid = formIdOf(form);
    if (fid && input.getAttribute('form') !== fid){
      input.setAttribute('form', fid);
    }

    function render(){
      var res = clean(input.value, maxLines);
      var lines = res.lines;

      text.textContent = lines.map(titleCase).join('\n');
      if (empty) empty.hidden = lines.length > 0;
      if (lines.length) fit(box, text);
      if (count) count.textContent = lines.length + ' of ' + maxLines + ' races';

      var problems = [];
      if (res.overflow > 0){
        problems.push('Only the first ' + maxLines + ' races will print - ' + res.overflow + ' more over the limit.');
      }
      var long = lines.filter(function(l){ return l.length > maxChars; });
      if (long.length){
        problems.push(long.length === 1 ? 'One line is long and will print small: "' + long[0] + '"' : long.length + ' lines are long and will print small.');
      }
      if (msg){
        msg.textContent = problems.join(' ');
        msg.hidden = problems.length === 0;
      }
    }

    input.addEventListener('input', render);
    input.addEventListener('change', render);
    input.addEventListener('blur', function(){
      var res = clean(input.value, maxLines);
      if (res.lines.length) input.value = res.lines.join('\n');
      render();
    });
    window.addEventListener('resize', function(){ if (input.value.trim()) render(); });

    if (document.fonts && document.fonts.load){
      document.fonts.load(PRINT_FONT).then(function(){ render(); }).catch(function(){});
    }

    if (required && form){
      form.addEventListener('submit', function(e){
        if (!clean(input.value, maxLines).lines.length){
          e.preventDefault();
          e.stopPropagation();
          if (msg){ msg.textContent = 'Please add at least one race before adding to cart.'; msg.hidden = false; }
          input.focus();
          input.scrollIntoView({ block: 'center' });
        }
      }, true);
    }

    if (new URLSearchParams(window.location.search).get('edit') === 'true' && window.Shopify && window.Shopify.routes){
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var pid = parseInt(root.dataset.productId, 10);
          var item = (cart.items || []).find(function(i){ return i.product_id === pid; });
          if (item && item.properties && item.properties['Race List']){
            input.value = item.properties['Race List'];
            render();
          }
        })
        .catch(function(){});
    }

    render();
  }

  function initAll(){ document.querySelectorAll('[data-dc-race]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
